export const InspectionStepTitle = () => {
  return (
    <div className="InspectionStepTitle">
      Note: Price increases after 40 Kms from Melbourne CBD.
    </div>
  );
};
